import _defineProperty from "/ecomm-marketplace/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import _ from 'lodash';
import LogRocket from 'shared/logrocket';
import { flattenedIntegrationsForSegment } from './integrations';
import { isSuperAdmin } from './users';
export var buildSuperAdminTraits = function buildSuperAdminTraits() {
  return {
    name: 'dutchie',
    tags: 'dispensary_user_segment'
  };
};
export var buildIntegrationsTraits = function buildIntegrationsTraits(dispoIntegrations) {
  var allIntegrations = flattenedIntegrationsForSegment();
  _.forEach(dispoIntegrations, function (integration) {
    allIntegrations[integration.adapter] = integration.live;
  });
  return allIntegrations;
};
export var buildDispensaryTraits = function buildDispensaryTraits(dispensary) {
  var _dispensary$location, _dispensary$location2, _dispensary$location3, _dispensary$location4;
  return {
    chain_id: dispensary === null || dispensary === void 0 ? void 0 : dispensary.chain,
    city: dispensary === null || dispensary === void 0 || (_dispensary$location = dispensary.location) === null || _dispensary$location === void 0 ? void 0 : _dispensary$location.city,
    country: dispensary === null || dispensary === void 0 || (_dispensary$location2 = dispensary.location) === null || _dispensary$location2 === void 0 ? void 0 : _dispensary$location2.country,
    embedded: !_.isEmpty(dispensary === null || dispensary === void 0 ? void 0 : dispensary.embeddedMenuUrl),
    id: dispensary === null || dispensary === void 0 ? void 0 : dispensary.id,
    name: dispensary === null || dispensary === void 0 ? void 0 : dispensary.name,
    phone: dispensary === null || dispensary === void 0 ? void 0 : dispensary.phone,
    postalCode: dispensary === null || dispensary === void 0 || (_dispensary$location3 = dispensary.location) === null || _dispensary$location3 === void 0 ? void 0 : _dispensary$location3.zipcode,
    state: dispensary === null || dispensary === void 0 || (_dispensary$location4 = dispensary.location) === null || _dispensary$location4 === void 0 ? void 0 : _dispensary$location4.state,
    subdomain: !_.isEmpty(dispensary === null || dispensary === void 0 ? void 0 : dispensary.customDomainSettings),
    status: dispensary === null || dispensary === void 0 ? void 0 : dispensary.status,
    tags: 'dispensary_user_segment',
    // these tags are needed for Zendesk downstream
    tier: dispensary === null || dispensary === void 0 ? void 0 : dispensary.tier,
    timezone: dispensary === null || dispensary === void 0 ? void 0 : dispensary.timezone
  };
};
export var buildTraitsFromUser = function buildTraitsFromUser(user) {
  var traits = {
    createdAt: user.createdAt,
    email: _.get(user, 'emails[0].address'),
    firstName: user.profile.firstName,
    lastName: user.profile.lastName,
    name: user.profile.fullName,
    phone: user.profile.phone
  };

  // flatten permissions
  _.merge(traits, user.profile.permissions);
  return traits;
};
function getEnvIdentifier(id) {
  return window.reactEnv.appEnv === 'production' ? id : 'developmentId';
}
export var segmentIdentifyAndGroup = function segmentIdentifyAndGroup(user, dispensary, integrations) {
  if (!window.analytics || !user) {
    return;
  }
  var userId = getEnvIdentifier(user._id);
  // in all cases at least call identify on the user
  window.analytics.identify(userId, _objectSpread({}, buildTraitsFromUser(user)));
  // if user is super admin, we want to add them to the dutchie org in zendesk
  if (isSuperAdmin(user)) {
    window.analytics.group('superAdminId', _objectSpread({}, buildSuperAdminTraits()));
  }
  // when dispensary data is provided, we can group it into an org downstream
  if (dispensary) {
    var traits = buildDispensaryTraits(dispensary);
    var dispoId = getEnvIdentifier(dispensary.id);
    if (integrations) {
      traits = _objectSpread(_objectSpread({}, traits), buildIntegrationsTraits(integrations));
    }
    window.analytics.group(dispoId, traits);
  }
};
export var configureLogRocket = function configureLogRocket(user) {
  if (!user) {
    return;
  }
  LogRocket.identify(user._id, buildTraitsFromUser(user));
};
export var openZendeskWidget = function openZendeskWidget() {
  if (_.isFunction(window.zE)) {
    try {
      window.zE('webWidget', 'open');
    } catch (error) {
      window.zE('messenger', 'open');
    }
  }
};
export var showZendeskWidget = function showZendeskWidget() {
  if (_.isFunction(window.zE)) {
    try {
      window.zE('webWidget', 'show');
    } catch (error) {
      window.zE('messenger', 'open');
    }
  }
};
export var hideZendeskWidget = function hideZendeskWidget() {
  if (_.isFunction(window.zE)) {
    try {
      window.zE('webWidget', 'hide');
    } catch (error) {
      window.zE('messenger', 'close');
    }
  }
};
export var closeZendeskWidget = function closeZendeskWidget() {
  if (_.isFunction(window.zE)) {
    hideZendeskWidget();
    // run this no matter what but also it can throw exceptions
    try {
      window.zE('messenger', 'close');
    } catch (e) {}
  }
};
export function hideDecagonWidget() {
  if (!window.duet) {
    return;
  }
  window.duet.hide();
}
export function showDecagonWidget() {
  if (!window.duet) {
    return;
  }
  window.duet.unhide();
}
export function openDecagonWidget() {
  if (!window.duet) {
    return;
  }
  window.duet.unhide();
  window.duet.open();
}
export function closeDecagonWidget() {
  if (!window.duet) {
    return;
  }
  window.duet.close();
}
export function openChatWidget() {
  openZendeskWidget();
  openDecagonWidget();
}